import { useCallback, useState } from 'react';

export const useInitialization = () => {
    const [isInitialized, setIsInitialized] = useState(false);

    const markAsInitialized = useCallback(() => {
        setIsInitialized(true);
    }, []);

    return { isInitialized, markAsInitialized };
};
